import { Route } from '@angular/router';

import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';

import { Role } from './core/auth/auth.types';
import { FilterStateService } from './shared/services/filter-state.service';
import { GlobalFilterStateService } from './shared/services/global-filter-state.service.old';
import { GlobalFilterService } from './shared/services/global-filter-state.service';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  // Redirect empty path to home/dashboard component
  { path: '', pathMatch: 'full', redirectTo: 'home' },

  // Auth routes for authenticated users
  {
    path: 'auth',
    canActivate: [autoLoginPartialRoutesGuard],
    canActivateChild: [autoLoginPartialRoutesGuard],
    component: LayoutComponent,
    providers: [
      FilterStateService,
      GlobalFilterService,
      GlobalFilterStateService,
    ],
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'logout',
        loadChildren: () => import('app/modules/auth/logout/logout.routes'),
      },
    ],
  },

  // General routes (authenticated users)
  {
    path: '',
    canActivate: [autoLoginPartialRoutesGuard],
    canActivateChild: [autoLoginPartialRoutesGuard],
    component: LayoutComponent,
    providers: [
      FilterStateService,
      GlobalFilterService,
      GlobalFilterStateService,
    ],
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: 'home',
        loadChildren: () => import('app/modules/landing/landing.routes'),
      },
      {
        path: 'logistics',
        loadChildren: () => import('app/modules/logistics/logistics.routes'),
      },
      {
        path: 'managed',
        loadChildren: () => import('app/modules/managed/managed.routes'),
      },
      {
        path: 'client-accounts',
        loadChildren: () =>
          import('app/modules/client-accounts/client-accounts.routes'),
      },
      {
        path: 'client-stocktake',
        loadChildren: () =>
          import(
            'app/modules/client-accounts/client-account-details/client-stocktake/client-stocktake.routes'
          ),
      },
      {
        path: 'managed/listings',
        loadChildren: () =>
          import(
            'app/modules/client-accounts/client-account-details/listings/listings.routes'
          ),
      },
      {
        path: 'billing',
        loadChildren: () => import('app/modules/billing/billing.routes'),
      },
      {
        path: 'stock-management',
        loadChildren: () =>
          import('app/modules/storage-management/storage-management.routes'),
      },
      {
        path: 'stocktake',
        loadChildren: () => import('app/modules/stocktake/stocktake.routes'),
      },
      {
        path: 'marketplace',
        loadChildren: () =>
          import('app/modules/marketplace/marketplace.routes'),
      },
      {
        path: 'sites',
        loadChildren: () => import('app/modules/sites/site.routes'),
      },
      {
        path: 'wine',
        loadChildren: () => import('app/modules/wine/wine.routes'),
      },
      {
        path: 'admin',
        data: {
          roles: [
            Role.SuperAdmin,
            Role.ITAdmin,
            Role.OpsAdmin,
            Role.Finance,
            Role.Reporting,
            Role.Support,
          ],
        },
        loadChildren: () => import('app/modules/admin/admin.routes'),
      },
    ],
  },

  // Routes for unauthenticated users (including auth errors)
  {
    path: 'forbidden',
    loadChildren: () => import('app/modules/auth/forbidden/forbidden.routes'),
  },
  {
    path: 'unauthorized',
    loadChildren: () =>
      import('app/modules/auth/unauthorized/unauthorized.routes'),
  },
  {
    path: 'auth-callback',
    loadChildren: () => import('app/modules/auth/callback/callback.routes'),
  },
];
